import { ActionReducer, Action } from '@ngrx/store';
import * as fromActions from './pages.actions';
import { PagesState } from './pages.state';
import { DO_GET_INFO_FILTERS, DO_SET_SELECTED_FILTERS } from './pages.actions';


const defaultState: PagesState = {
    loading: true,
    error: '',
    pages: [],
    ordersby: [],
    paginator: {
        total: 0,
        perPage: 100,
        currentPage: 1,
        lastPage: 0
    },
    filtersStatus: [
        { value: 1 , name: 'Activo' },
        { value: 0 , name: 'Inactivo' }
    ],
    // search: '',
    currentFilters: {
        textSearch: '',
        status: -1,
        type: ''
    },
    refresh: false
};

export type Action = fromActions.All;

export function PagesReducer(state = defaultState, action: any) {
    switch (action.type) {

        case fromActions.DO_GET_INFO_PAGES:
            // console.log('pidiendo...');
            return {
                ...state,
                loading: true,
                error: '',
                pages: [],
                refresh: false
            };

        case fromActions.DO_GET_INFO_PAGES_OK:
            return {
                ...state,
                loading: false,
                pages: action.payload.list,
                paginator: {
                    total: action.payload.pagination.total,
                    perPage: action.payload.pagination.limit,
                    currentPage: action.payload.pagination.page,
                    lastPage: action.payload.pagination.pages
                }
            };

        case fromActions.DO_GET_INFO_PAGES_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                pages: [],
                paginator: null
            };

        case fromActions.DO_GET_INFO_FILTERS:
            // console.log('pidiendo...');
            return {
                ...state,
                loading: false,
                error: ''
            };

        case fromActions.DO_GET_INFO_FILTERS_OK:
            return {
                ...state,
                loading: false

            };

        case fromActions.DO_GET_INFO_FILTERS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case fromActions.DO_SET_SELECTED_FILTERS:
            return {
                ...state,
                loading: false,
                currentFilters: action.payload.filters,
                paginator: action.payload.paginator,
                refresh: true
            };

        default:
            return state;
    }
}
